import {
  LIST_INFO_BOX_MULTI,
  EXCEL_LIST_INFO_BOX_MULTI,
  INSURANCE_BOX_MULTI,
  INFO_BOX_MULTI,
  PRICE_BOX_MULTI,
  WEIGHT_BOX_MULTI,
  SIZE_BOX_MULTI,
  LENGTH_BOX_MULTI,
  WIDTH_BOX_MULTI,
  HEIGHT_BOX_MULTI,
  RESET_STATE_BOX_MULTI,
  AGENT_SERVICES_BOX_MULTI
} from "../../Types";


const initialState = {
  list: [],
  excelList: [],
  insurance: '',
  info: '',
  price: '',
  weight: '',
  size: '',
  length: '',
  width: '',
  height: '',
  agent_services: '',
}

export const multiInfoBoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_INFO_BOX_MULTI: {
      return {
        ...state,
        list: action.payload,
      };
    }
    case EXCEL_LIST_INFO_BOX_MULTI: {
      return {
        ...state,
        excelList: action.payload,
      };
    }
    case INSURANCE_BOX_MULTI: {
      return {
        ...state,
        insurance: action.payload,
      };
    }
    case INFO_BOX_MULTI: {
      return {
        ...state,
        info: action.payload,
      };
    }
    case PRICE_BOX_MULTI: {
      return {
        ...state,
        price: action.payload,
      };
    }
    case WEIGHT_BOX_MULTI: {
      return {
        ...state,
        weight: action.payload,
      };
    }
    case SIZE_BOX_MULTI: {
      return {
        ...state,
        size: action.payload,
      };
    }
    case LENGTH_BOX_MULTI: {
      return {
        ...state,
        length: action.payload,
      };
    }
    case WIDTH_BOX_MULTI: {
      return {
        ...state,
        width: action.payload,
      };
    }
    case HEIGHT_BOX_MULTI: {
      return {
        ...state,
        height: action.payload,
      };
    }
    case AGENT_SERVICES_BOX_MULTI: {
      return {
        ...state,
        agent_services: action.payload,
      };
    }
    case RESET_STATE_BOX_MULTI:
      return initialState;
    default:
      return state;
  }
};
